/**
 * WHAT THE BROWSER HOLDS ABOUT WHO IS SIGNED IN, and the one part of it that goes stale.
 *
 * `GET /api/me` answers with the business day as the server counts it, and every screen that says
 * "Today", offers yesterday and tomorrow, or refuses a date in the past reads that one string. It
 * was read once, at boot, and never again, so a tab left open overnight went on calling yesterday
 * Today and went on refusing the real date. Nobody reloads a browser tab at midnight; the phone in
 * the car is the same tab it was at eight in the morning.
 *
 * The repair is not a timer. The day is asked for again on the schedule the rail counts already
 * ride, a route change, and once more when the tab comes back to the front, which is the moment
 * somebody is looking at it after leaving it alone. Both are things a person did, so neither costs
 * a request while the phone is in a pocket.
 *
 * `withToday` is why that is safe to wire into an effect. It hands back the SAME object when the
 * day has not moved, so re-reading the day on every route change re-renders nothing and cannot
 * feed itself: an effect that depends on the person would otherwise run, set a new object, and run
 * again for ever.
 */
import type { Me } from './api.ts';

export function withToday(me: Me, today: string | null): Me {
  if (today === null || today === '' || today === me.today) return me;
  return { ...me, today };
}
